import {Vue} from 'ui.vue';

const MOBILE_BREAKPOINT = 400;

export let CatalogSectionSlider = {
	name: 'CatalogSectionSlider',
	/*mixins: [BX.Citrus.Vue.Component.BulletsRestClient],*/
	props: {},
	data: function () {
		return {
			settings: {
				title: '',
				url: '',
				sliderHasBtn: true,
			},
			slider: null,
			products: [],
			swiperOption: {
				slidesPerView: 'auto',
				spaceBetween: 20,
				breakpoints: {
					320: {
						slidesPerView: 'auto',
						spaceBetween: 20,
					},
					1025: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					1201: {
						slidesPerView: 4,
					},
				},
				navigation: {
					nextEl: 'swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			},
			loading: false,
			isShowProductDescription: true
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CATALOG_SECTION_");
		},
	},
	/*created() {
		this.getBulletsInfo(this.products, this.bulletsProperty);
	},*/
	mounted() {
		this.swiperOption.navigation.nextEl = this.$options.el + " .swiper-button-next";
		this.swiperOption.navigation.prevEl = this.$options.el + " .swiper-button-prev";
		this.swiperOption.pagination.el = this.$options.el + " .swiper-pagination";

		if (window.innerWidth < 400) {
			this.swiperOption.pagination.type = "fraction";
		}

		this.slider = new Swiper(this.$refs.sliderProducts, this.swiperOption);
	},
};

export default {CatalogSectionSlider};
